import { ROUTERS } from '@/router/routers';
import { RouterProvider, BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConfigProvider, Divider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import { Provider } from 'react-redux';
import store from '@/store/index';
import { createContext, useState, Component } from 'react';

export const SocketsContext = createContext([]);
function App() {
    const [sockets, setSockets] = useState([]);

    return (
        <ConfigProvider
            locale={zhCN}
            theme={{
                token: {
                    borderRadius: 4,
                    borderRadiusLG: 4,
                },
            }}
        >
            <Provider store={store}>
                <SocketsContext.Provider value={{ sockets, setSockets }}>
                    <RouterProvider router={ROUTERS}></RouterProvider>
                </SocketsContext.Provider>
            </Provider>
        </ConfigProvider>
    );
}

export default App;
